"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
/**
 * exemple d'utilisation :<br/>
 *         <tl-button-with-subactions label="Actions" main-action-click="myMainAction()">
 *             <tl-subaction-item ng-click="openModal()"><span>Ouvre modale</span></tl-subaction-item>
 *             <tl-subaction-item><a href="/tael/inventaire">Inventaire</a></tl-subaction-item>
 *             <tl-subaction-item><a href="/tael/reporting"><span>Rapports</span></a></tl-subaction-item>
 *         </tl-button-with-subactions>
 */
ngModule.directive("tlButtonWithSubactions", function () {
  return {
    restrict: "E",
    transclude: true,
    scope: {
      label: '@',
      mainActionClick: '&?',
      // Add a new scope property for the main action click
      iconClass: '@?'
    },
    template: "\n            <div class=\"tl-button-with-subactions\">\n                <button ng-if=\"nbItems()!=1\" class=\"btn btn-primary\">\n                    <div class=\"button-container\">\n                    <span class=\"main-action\" ng-click=\"mainActionClick()\"><i ng-if=\"iconClass\" ng-class=\"iconClass\" class=\"main-action-icon\"></i> {{label}}</span>\n                    <i class=\"caret\" ng-click=\"toggleMenu()\" ng-show=\"nbItems()>1\" ng-class=\"{'fa fa-caret-down': !menuVisible, 'fa fa-caret-up': menuVisible}\"></i>\n                    </div>\n                    </button>\n                <ul class=\"subactions\" ng-show=\"menuVisible && nbItems()>1\" ng-transclude></ul>\n            </div>\n        ",
    controller: function controller($scope, $element, $document) {
      $scope.menuVisible = false;
      var handler = function handler(event) {
        if ($scope.menuVisible && !$element[0].contains(event.target)) {
          $scope.$apply(function () {
            $scope.menuVisible = false;
          });
        }
      };
      $document.on('click', handler);
      $scope.$on('$destroy', function () {
        $document.off('click', handler);
      });
      $scope.toggleMenu = function () {
        $scope.menuVisible = !$scope.menuVisible;
      };
      $scope.nbItems = function () {
        var entrees = $element.find('ul li');
        return entrees.length;
      };
    }
  };
});
ngModule.directive("tlSubactionItem", function () {
  return {
    restrict: 'E',
    require: '^tlButtonWithSubactions',
    transclude: true,
    template: '<li ng-transclude></li>'
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/buttons/tl-button-with-subactions.js
// module id = 2921
// module chunks = 13